import { LoggedUser } from "../models/Person";
import { PostApi } from "../pages/DashBoard/partials/Feed/types/types";
import { buildFeedPostUpdateFormData } from "./buildFeedPostUpdateFormData";
import { getParsedArray } from "./getParsedArray";
import { generateUniqueId } from "./useMockData";

interface NewPostDataProps {
  user: LoggedUser;
  post: PostApi;
  content: string;
}

export const createNewCommentFormData = ({user, post, content}: NewPostDataProps) => {
  const parsedComments = getParsedArray(post.comments);
  const isLastNameEmpty = user.last_name == undefined || user.last_name == null;
  let userName = user.name;
  if (!isLastNameEmpty) {
    userName = `${user.name} ${user.last_name}`
  }
  const addingComment = {
    content: content,
    user_id: user.id,
    user_name: userName,
    comment_id: generateUniqueId(),
    avatar_url: user.avatar_url,
    created_at: new Date().toISOString(),
    edited_at: new Date().toISOString(),
  };

  return buildFeedPostUpdateFormData(post, {
    comments: JSON.stringify([...parsedComments, addingComment]),
  });
};
